export const PostStatus = {
    DRAFT: 'DRAFT',
    PUBLISHED: 'PUBLISHED'
};
//# sourceMappingURL=post.constant.js.map